///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component } from '@angular/core';
import { AbstractDialogManager } from '../../../dialog-manager/abstract-dialog-manager';
import { UserDTO } from '../../../generated/shared-types.model';
import { UserDialogComponent } from './user-dialog.component';
import { SuiUserDTO } from '../../../generated/shared-sui-types.model';
import { UserAuthorities } from '../../../services/user/user-authorities';
import { ACCOUNTANTS_BASE_URL, CUSTOMERS_SUPPORT_BASE_URL, SALES_BASE_URL } from '../../../engineers-config/engineers.constants';
import { USERS_BASE_URL } from '../../../users-config/users.route';
import { CUSTOMERS_BASE_URL } from '../../../customers-config/customers.route';

@Component({
    template: '',
    standalone: false
})
export class CreateUserDialogWrapperComponent extends AbstractDialogManager<SuiUserDTO, UserDialogComponent> {
    constructor() {
        super(UserDialogComponent);
        this.openDialog();
    }

    preparingBaseConfig(): void {
        this.baseConfig.width = '800px';
        this.baseConfig.position = { top: '30px' };
        const panelType: string = this.activatedRoute.snapshot.url[1].path;
        const authorities: UserAuthorities[] = this.getAuthorities(panelType);
        const customerId = +this.activatedRoute.snapshot.paramMap.get('customerId') || null;
        this.baseConfig.data.payload = new SuiUserDTO({ authorities, customerId } as UserDTO);
    }

    private getAuthorities(panelType: string): UserAuthorities[] {
        switch (panelType) {
            case ACCOUNTANTS_BASE_URL:
                return [UserAuthorities.SIKLU_ACCOUNTANT];
            case CUSTOMERS_SUPPORT_BASE_URL:
                return [UserAuthorities.SIKLU_CUSTOMER_SUPPORT];
            case SALES_BASE_URL:
                return [UserAuthorities.SIKLU_SALES];
            case USERS_BASE_URL:
            case CUSTOMERS_BASE_URL:
                return [UserAuthorities.COMPANY_USER];
        }
    }
}
